import React from 'react';
import { ChartNoAxesGantt, ChevronRight } from 'lucide-react';
import { Menu, MenuHandler, MenuItem, MenuList } from '@material-tailwind/react';
import { TbMenu3 } from "react-icons/tb";

const menuItems = [
  { title: 'Méthodologie NextMaker', link: '/next-maker-method' },
  { title: 'Disciplines', link: '/courses-list' },
  { title: 'Nos tuteurs', link: '/instructors-list' },
  { title: 'Summer Maker Stage ', link: '/summer-maker-stages' },
  { title: 'Offre Ecoles', link: '/school-offer' }
];

const ExploreDropdown = ({ buttonColor, border }) => {
  return (
    <div className={`relative h-[25.5px] flex items-center px-4 md:px-[30px] xl:px-[20px]
    ${border ? 'border-r border-l border-gray-200 dark:border-gray-700' : ''}`}>
      <Menu placement="bottom-start">
        <MenuHandler>
          <button className={`flex items-center gap-2 h-full ${buttonColor}
          rounded-lg transition-colors`}>
            <TbMenu3 className="w-5 h-5 md:w-5 md:h-5 transition-transform" />
            <span className="font-semibold text-normal hidden md:block">
              En savoir plus
            </span>
          </button>
        </MenuHandler>

        <MenuList className="p-2 text-dark-1 dark:text-white dark:bg-dark-2 z-[100] min-w-[220px]">
          {menuItems.map((item, index) => (
            <div key={index}>
              <MenuItem className="py-2 px-4 text-normal text-start hover:bg-light-3 hover:text-purple-1">
                <a href={item.link}>{item.title}</a>
              </MenuItem>
            </div>
          ))}
        </MenuList>
      </Menu>
    </div>
  );
};

export default ExploreDropdown;